import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import fr from "./locales/fr";
import en from "./locales/en";
import de from "./locales/de";
import { rebrandTree, rebrandPlugin } from "./lib/rebrand";

const applyBrand = rebrandTree;

const resources = {
  fr: { translation: applyBrand(fr) },
  en: { translation: applyBrand(en) },
  de: { translation: applyBrand(de) }
};

if (rebrandPlugin) i18n.use(rebrandPlugin);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    postProcess: rebrandPlugin ? ["rebrand"] : [],
    fallbackLng: "fr",
    initImmediate: false,
    react: {
      useSuspense: false,
    },
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
    },
  });

if (typeof window !== "undefined") {
  window.__i18n = i18n;
}

export default i18n;
